import React from 'react';
import './styles.scss';
import Table from '../../../../components/table';
import { connect } from 'react-redux';

class DashboardTopic extends React.Component {
	constructor(props, context) {
		super(props, context);
		this.state = {
			// eslint-disable-next-line react/no-unused-state
			selectedDate: '2019/8/6',
		};
		this.onChange = this.onChange.bind(this);
	}

	onChange(date) {
		this.setState({
			// eslint-disable-next-line react/no-unused-state
			selectedDate: date,
		});
	}

	render() {
		return (
			<div className="wrap-dashboard-topic">
				<div className="title--dashboard  justify-content-between">
					<h1>My Topics</h1>
					<div className="title--dashboard-right  align-items-center">
						<div className="search-topic">
							<input placeholder="検索" />
						</div>
						<div className="add-topic">
							<button type="button" className="btn">Topicsを作成</button>
						</div>
					</div>
				</div>

				<div className="body--tables">
					<div className="wrap-table-topic ">
						<Table
							header={this.props.header}
							showCheckbox={false}
							showSearch={false}
							itemOfPage={this.props.table}
							isShowOptionTable={false}
						/>
					</div>

				</div>
			</div>
		);
	}
}

const mapStateToProps = ({ dashboardTopic }) => {
	return {
		header: dashboardTopic.header,
		table: dashboardTopic.table
	}
};

const mapDispatchToProps = dispatch => {
	return {

	}
};

export default connect(mapStateToProps, mapDispatchToProps, null, { pure : false })(DashboardTopic);
